module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "notice-inner"
  }, [_vm._v(_vm._s(_vm.item.content) + "\n    "), _c('a', {
    attrs: {
      "href": "javscript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.$emit('toDetail', _vm.item.id)
      }
    }
  }, [_vm._v("查看详情")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca8c4ea","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/NoticeInnerLink.vue
// module id = 766
// module chunks = 0